import useApiServices from './useApiServices';
import { globalAdminUrl } from './globalApi';
//
/**
 * @module AdminServiceService
 * @returns  it return All DataSource Apis
 */

const ReportService = {
  ReportsGridList: (credential, token) =>
    useApiServices().postApi(
      `${globalAdminUrl}/reports/v1/grid-list/mis-reports`,
      credential,
      token
    ),
  DownloadMisReports: (credential, token) =>
    useApiServices().postApiBlob(
      `${globalAdminUrl}/reports/v1/download-mis-reports`,
      credential,
      token
    )
};

export default ReportService;
